module.exports = __webpack_public_path__ + "img/core-group3.9cce8a11.png";